<template>
  <div class="flex fullscreen">
    <div class="w-full flex flex-col justify-center items-center bg-gray-300 px-4 md:px-0">
      <div>
        <svg
          class="mx-auto h-24 w-auto text-primario"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 64 91"
        >
          <path d="M31.3799 58.9268c-.2318.1738-.3563.2579-.4722.3535-1.2864 1.0517-2.5728 2.1063-3.8592 3.1609-.9271.759-1.8629.7996-2.8509.1158-1.3182-.9155-2.6336-1.831-3.9518-2.7465-.1478-.1043-.3071-.1913-.4897-.3043-.0347.142-.0637.2144-.0724.2898-.2521 2.6683-.4954 5.3367-.762 8.0022-.0377.3882.1536.4954.4491.6113 2.6162 1.0343 5.328 1.6746 8.1239 1.9556.9445.0956 1.8977.113 2.8828.1709.3361-3.891.6634-7.6834 1.0024-11.6092zM24.9538 45.22c1.5703 2.2077 1.9122 4.4298.846 6.7418-1.072 2.3294-3.0131 3.4999-5.6496 3.7404 1.3588 1.2371 2.6249 2.3931 3.9112 3.5665.9069-.6983 1.8398-.7504 2.8046-.1623 1.4892-1.4225 2.9552-2.8364 4.4415-4.2241.339-.3158.5041-.6519.5331-1.1126.084-1.2893.2144-2.5727.3245-3.8591.0956-1.1415.1854-2.2859.2839-3.5057-2.5785.1797-5.0122-.1796-7.4952-1.1849z" />
          <path d="M32.4317 9.7839c1.1009.15066 2.2135.2405 3.2999.4665 12.3191 2.5553 20.4545 9.8419 24.0095 21.8915 2.3033 7.8081 1.2342 15.4162-2.6192 22.6071-.0724.1391-.1535.2724-.2317.4086-.0203.0318-.0522.0579-.1275.139-5.1252-4.1604-10.2533-8.3266-15.4162-12.5189 4.0938-3.6564 6.061-8.1876 5.6177-13.6402-.3418-4.2213-2.1816-7.7588-5.3599-10.5663-6.3565-5.6148-16.126-5.16-21.9813.9503-6.2001 6.4725-6.0118 17.3197 1.5268 23.4821-2.7292-.3013-4.9311.5592-6.4202 2.8104-1.4892 2.2511-1.3936 4.6008-.058 6.9736-2.9899 1.6051-5.9683 3.2015-8.99881 4.8297-.12458-.1709-.25496-.3332-.37085-.5041-2.9407-4.398-4.650066-9.2277-5.070166-14.5094-.014486-.1709-.066636-.3419-.101403-.5128v-3.8765c.034767-.1709.075328-.3419.104301-.5128.318696-1.8455.504119-3.7259.979268-5.5308C4.17202 20.9006 13.8198 12.1307 25.2552 10.2417c1.0952-.1797 2.199-.30714 3.3-.46069 1.2921.00289 2.5843.00289 3.8765.00289zM31.38 58.9265c-.339 3.9258-.6664 7.7212-1.0024 11.6121-.9851-.055-1.9383-.0753-2.8828-.1709-2.7958-.281-5.5076-.9213-8.1238-1.9556-.2984-.1188-.4896-.2231-.4491-.6113.2666-2.6655.5099-5.3339.762-8.0022.0058-.0753.0377-.1507.0724-.2897.1825.113.3419.1999.4896.3042 1.3183.9126 2.6336 1.831 3.9519 2.7466.9879.6837 1.9237.646 2.8508-.1159 1.2864-1.0546 2.5728-2.1092 3.8592-3.1609.1159-.0985.2404-.1826.4722-.3564z" />
          <path d="M24.9539 45.22c2.4858 1.0053 4.9166 1.3646 7.4951 1.182-.0985 1.2198-.1883 2.3613-.2839 3.5057-.1072 1.2863-.2376 2.5727-.3245 3.8591-.0319.4606-.1941.7967-.5331 1.1125-1.4863 1.3877-2.9523 2.8016-4.4414 4.2241-.9648-.5881-1.8977-.536-2.8045.1623-1.2863-1.1734-2.5524-2.3265-3.9112-3.5665 2.6364-.2376 4.5776-1.411 5.6495-3.7403 1.0633-2.3091.7214-4.5284-.846-6.7389z" />
        </svg>
        <h2 class="text-center text-3xl leading-9 font-extrabold text-primario tracking-wide">
          {{ $t("lang.fields.signUser") }}
        </h2>
      </div>
      <div
        v-show="!isUserCreated"
        class="w-full bg-white p-4 md:p-8 mt-6 rounded-lg shadow-lg max-w-xl"
      >
        <transition
          mode="in-out"
          enter-active-class="transition-all duration-1000 ease-linear transform"
          enter-class="-translate-x-20 opacity-0"
          enter-to-class="translate-x-0 opacity-100"
          leave-active-class="transition-all duration-1000 ease-linear"
          leave-class="translate-x-0 opacity-100"
          leave-to-class="translate-x-20 opacity-0"
        >
          <form method="post" @submit.prevent="createUser">
            <div class="w-full space-y-4 max-w-xl">
              <InputWrapper :label="$t('lang.fields.email')" content="input" block>
                <input
                  :name="$t('lang.fields.email')"
                  type="email"
                  required
                  v-model="credentials.userEmail"
                  class="form-input w-full border-gray-500 tracking-wide"
                  placeholder="email@dominio.com"
                  aria-label="email@dominio.com"
                >
              </InputWrapper>

              <InputWrapper :label="$t('lang.fields.password')" content="input" block>
                <input
                  type="password"
                  name="password"
                  required
                  placeholder="********"
                  v-model="credentials.userPassword"
                  class="form-input w-full border-gray-500 tracking-wide"
                  :aria-label="$t('lang.fields.password')"
                >
              </InputWrapper>

              <InputWrapper :label="$t('lang.msg.type')" content="input" block>
                <Select
                  id="id"
                  class="h-10"
                  :data="userTypes"
                  :track-by="getLangLabel('type')"
                  v-model.number="userType"
                />
              </InputWrapper>

              <InputWrapper :label="$t('lang.msg.language')" content="input" block>
                <Select
                  id="id"
                  class="h-10"
                  :data="languages"
                  :track-by="getLangLabel('language')"
                  v-model="credentials.userLanguage"
                />
              </InputWrapper>
            </div>

            <button type="submit" class="relative block w-full mt-6 py-2 px-3 border border-transparent rounded-md bg-primario focus:bg-primario focus:outline-none focus:shadow-outline">
              <span
                class="text-sm font-semibold text-gray-100 sm:leading-5 uppercase"
              >{{ $t('lang.msg.next') }}</span>
            </button>
          </form>
        </transition>
      </div>

      <div
        v-show="isUserCreated"
        class="w-full bg-white p-4 md:p-8 mt-6 rounded-lg shadow-lg max-w-xl"
      >
        <transition
          mode="out-in"
          enter-active-class="transition-all duration-1000 ease-linear"
          leave-active-class="transition-all duration-1000 ease-linear"
          enter-class="-transition-x-8 opacity-0"
          enter-to-class="transition-x-0 opacity-100"
          leave-class="opacity-100"
          leave-to-class="transition-x-8 opacity-0"
        >
          <form method="post" @submit.prevent="finishSignup">
            <div v-if="userType == 0" class="w-full space-y-4 max-w-xl">
              <!-- ============== -->
              <!-- === CLIENT === -->
              <!-- ============== -->
              <InputWrapper :label="$t('lang.fields.name')" content="input" block>
                <InputText v-model="buyer.buyerName" :name="$t('lang.fields.name')" />
              </InputWrapper>
              <InputWrapper :label="$t('lang.fields.lastname')" content="input" block>
                <InputText v-model="buyer.buyerLastName" :name="$t('lang.fields.lastname')" />
              </InputWrapper>
              <InputWrapper :label="$t('lang.fields.address')" content="input" block>
                <InputText v-model="buyer.buyerAdress" :name="$t('lang.fields.address')" />
              </InputWrapper>
              <InputWrapper :label="$t('lang.fields.phone')" content="input" block>
                <InputText v-model="buyer.buyerPhone" :name="$t('lang.fields.phone')" />
              </InputWrapper>
              <InputWrapper :label="$t('lang.msg.client')" content="input" block>
                <Select
                  id="idClient"
                  :data="clients"
                  track-by="clientName"
                  v-model.number="buyer.idClient"
                />
              </InputWrapper>
            </div>
            <!-- ================== -->
            <!-- === EUROPROSEM === -->
            <!-- ================== -->
            <div v-if="userType == 1" class="w-full space-y-4 max-w-xl">
              <InputWrapper :label="$t('lang.fields.name')" content="input" block>
                <InputText v-model="employee.employeeName" :name="$t('lang.fields.name')" />
              </InputWrapper>
              <InputWrapper :label="$t('lang.fields.lastname')" content="input" block>
                <InputText v-model="employee.employeeLastName" :name="$t('lang.fields.lastname')" />
              </InputWrapper>
              <InputWrapper :label="$t('lang.fields.address')" content="input" block>
                <InputText v-model="employee.employeeAdress" :name="$t('lang.fields.address')" />
              </InputWrapper>
              <InputWrapper :label="$t('lang.fields.phone')" content="input" block>
                <InputText v-model="employee.employeePhone" :name="$t('lang.fields.phone')" />
              </InputWrapper>
              <InputWrapper :label="$t('lang.msg.roles')" content="input" block>
                <Select
                  id="idRol"
                  :data="roles"
                  track-by="rolName"
                  v-model.number="employee.idRol"
                />
              </InputWrapper>
              <InputWrapper :label="$t('lang.msg.company')" content="input" block>
                <Select
                  id="idCompany"
                  :data="companies"
                  track-by="companyName"
                  v-model.number="employee.idCompany"
                />
              </InputWrapper>
            </div>
            <!-- =============== -->
            <!-- === FACTORY === -->
            <!-- =============== -->
            <div v-if="userType == 2" class="w-full space-y-4 max-w-xl">
              <InputWrapper :label="$t('lang.fields.name')" content="input" block>
                <InputText v-model="factory.factoryName" :name="$t('lang.fields.name')" />
              </InputWrapper>
              <InputWrapper :label="$t('lang.msg.ubication')" content="input" block>
                <InputText v-model="factory.factoryLocation" :name="$t('lang.msg.ubication')" />
              </InputWrapper>
              <div class="flex space-x-4">
                <InputWrapper :label="$t('lang.fields.cif')" content="input" block>
                  <InputText v-model="factory.cif" :name="$t('lang.fields.cif')" />
                </InputWrapper>
                <InputWrapper :label="$t('lang.fields.phone')" content="input" block>
                  <InputText v-model="factory.phone" :name="$t('lang.fields.phone')" />
                </InputWrapper>
              </div>
              <InputWrapper :label="$t('lang.fields.email')" content="input" block>
                <InputText v-model="factory.mail" type="email" :name="$t('lang.fields.email')" />
              </InputWrapper>
              <InputWrapper :label="$t('lang.fields.address')" content="input" block>
                <textarea
                  class="form-textarea w-full"
                  v-model="factory.factoryAdress"
                  :placeholder="$t('lang.fields.address')"
                />
              </InputWrapper>
              <InputWrapper :label="$t('lang.fields.anotations')" content="input" block>
                <textarea
                  class="form-textarea w-full"
                  v-model="factory.anotations"
                  :placeholder="$t('lang.fields.anotations')"
                />
              </InputWrapper>
            </div>

            <!-- ===================== -->
            <!-- === FINISH SIGNUP === -->
            <!-- ===================== -->
            <button type="submit" class="relative block w-full mt-6 py-2 px-3 border border-transparent rounded-md bg-primario hover:bg-primario focus:bg-primario focus:outline-none focus:shadow-outline">
              <span class="text-sm font-semibold text-gray-100 sm:leading-5 uppercase">
                {{ $t('lang.fields.signUp') }}
              </span>
            </button>
          </form>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import UtilsMixin from "@/components/mixins/UtilsMixin";
export default {
  name: "Signup",
  mixins: [UtilsMixin],
  data() {
    return {
      clients: [],
      userType: 0,
      isUserCreated: false,
      credentials: {
        userLanguage: null
      },
      buyer: {},
      employee: {},
      factory: {},
      roles: [],
      userTypes: [
        { id: 0, typeEs: "Cliente", typeEn: "Client" },
        { id: 1, typeEs: "Equipo europrosem", typeEn: "Europrosem team" },
        { id: 2, typeEs: "Fábrica", typeEn: "Factory" }
      ],
      languages: [
        { id: "es", languageEs: "Español", languageEn: "Spanish" },
        { id: "en", languageEs: "Inglés", languageEn: "English" }
      ]
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      Promise.all([
        this.$axios.get(`api/Companies/GetCompany`),
        this.$axios.get(`api/Clients/GetAllClient`),
        this.$axios.get(`api/Rols/GetRol`)
      ]).then((values) => {
        this.companies = this.getActive(values[0].data, 'active');
        this.clients = this.getActive(values[1].data, 'active');
        this.roles = values[2].data;
      });
    },
    createUser() {
      this.$axios
        .post(`api/Users/Add`, this.credentials)
        .then(() => {
          this.isUserCreated = true;
        })
        .catch(() => this.showFriendlyError());
    },
    finishSignup() {
      let url = "";
      let params = {};

      switch (this.userType) {
        case 0: // Cliente
          url = "api/Buyers/Add";
          params = this.buyer;
          break;
        case 1: // EQUIPO EUROPROSEM
          url = "api/Employees/Add";
          params = this.employee;
          break;
        case 2: // Fábrica
          url = "api/Factories/Add";
          params = this.factory;
          break;
      }

      this.$axios
        .post(url, params)
        .then(() => {
          this.openAlert("success", "Usuario creado", null);
          this.$router.push({ name: "home" });
        })
        .catch(() => this.showFriendlyError());
    }
  }
};
</script>